
export function transaction(prefix: string) {
  
    return {
      ROOT: prefix,
      CONSULT_UNPROCESSED_TRANSACTIONS: `${prefix}/consult-unprocessed-transactions`,
      MAINTENANCE_UNPROCESSED_TRANSACTIONS: `${prefix}/maintenance-unprocessed-transactions`,
      CONSULT_PROCESSED_TRANSACTIONS: `${prefix}/consult-processed-transactions`,
      CONSULT_DUPLICATED_TRANSACTIONS: `${prefix}/consult-duplicated-transactions`,
    }
}
